import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class StockService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getStockUser(){
    return this.authHttp.get("/api/stock/user").map( res =>{
       return { 'status': res.status, 'value': res.json() }
    });
  }

  getStockOrderId(){
    return this.authHttp.get('api/stock/StockOrderId').map( (res:any)=>{
      return {'status': res.status, 'value': res.json() }
    })
  }


  getStockItems(){
    return this.authHttp.get("/api/stock").map(res => res.json());
  }

  transferStock(items:any){   
    return this.authHttp.post("/api/stock/transferstock/", items).map(res => {
      return { 'status': res.status, 'value': res.json() }
    })
  }

  getOrderedStockItems(){
    return this.authHttp.get("/api/stock/getOrderedStock").map(res => {
      return {'status': res.status,'value':res.json()}
    });
  }

  transferCartToStock(items: any){
    return this.authHttp.post("/api/stock/transferCartToStock", items).map( res => {
      return {'status': res.status}
    })
  }

  updateStockAmount(stockid: number, amount:number){  
    return this.authHttp.put(`/api/stock/updateAmount/${stockid}/${amount}`,null).map( (res:any) => {
      return {'status': res.status}
    })
  }

  addItemToStock(clothesId: number, size: string, amount:number){
    return this.authHttp.post(`/api/stock/addItemsDirectToStock/${clothesId}/${size}/${amount}`, null).map ( (res:any)=>{
      return {'status': res.status}
    })
  }

  deleteStockItem(id:number){
    return this.authHttp.delete(`/api/stock/delete/${id}`).map( (res:any)=>{
      return {'status': res.status}
    })
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/stock.service.ts